import { Brace, FloatImage, Loader, Panel, Tooltip, Typography, } from "@bracket/ui";
import { useVaults, } from "@store";
import styled from "styled-components";



export const MorphoDashboard = () => {

	const { ready, } = useVaults();

	if(!ready) return <Loader center />

	return (
		<Brace $gap="1rem">
			<Typography variant="h6">Morpho Dashboard</Typography>
			<Grid>
				<ValuePanel title="Total Users" value="100" tooltip="Total users on the platform" />
				<ValuePanel title="Total Users" value="200" tooltip="Total users on the platform22" />
				<ValuePanel title="Total Users3" value="100" tooltip="Total users on the platform" />
				<ValuePanel title="Total Users4" value="200" tooltip="Total users on the platform22" />
				<ValuePanel title="Total Users5" value="100" tooltip="Total users on the platform" />
				<ValuePanel title="Total Users6" value="200" tooltip="Total users on the platform22" />
			</Grid>
		</Brace>
	);
}




export declare type ValuePanelProps = {
	title: string;
	value: string;
	tooltip: string;
}

export const ValuePanel = ({
	title,
	value,
	tooltip,
}: ValuePanelProps) => {
	return (
		<Panel $strata="default" $position="relative" $gap="0.5rem">
			<FloatImage url="/logos/morpho-logo.svg" $anchor="top-right" $spacing="1rem" $width="22px" $height="22px" />
			{ title && !tooltip && <Typography variant="h6">{title}</Typography> }
			{ title && tooltip && <ToolTipCell><Typography variant="p" color="grey">{title}</Typography><Tooltip message={tooltip} /></ToolTipCell> }
			{ value && <Typography variant="p">{value}</Typography> }
		</Panel>
	);
}

const ToolTipCell = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	gap: 0.5rem;
`;

const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 1rem;
	@media (max-width: 1024px) {
		grid-template-columns: repeat(1, 1fr);
	}
	@media (max-width: 768px) {
		grid-template-columns: repeat(1, 1fr);
	}
`;
